import { render, staticRenderFns } from "./Expohallbird.vue?vue&type=template&id=130277d0&scoped=true&"
import script from "./Expohallbird.vue?vue&type=script&lang=js&"
export * from "./Expohallbird.vue?vue&type=script&lang=js&"
import style0 from "./Expohallbird.vue?vue&type=style&index=0&scope=true&lang=css&"
import style1 from "./Expohallbird.vue?vue&type=style&index=1&id=130277d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130277d0",
  null
  
)

export default component.exports